import { ClientTimestamp } from '../shared-types.js';

export enum AssetFileSize {
  original = 'ORIGINAL',
  fprint = 'FPRINT',
  videoStream = 'VIDEO_STREAM',
  size100 = '100x100',
  size200 = '200x200',
  size300 = '300x300',
  size1000 = '1000x1000',
  size300BlockedWatermark = '300x300_BLOCKED_WATERMARK',
  size1000BlockedWatermark = '1000x1000_BLOCKED_WATERMARK',
  size1000Page = '1000x1000_PAGE',
}

export interface AssetFile {
  size: AssetFileSize;
  fileName: string;
  filePath: string;
  creationDate?: ClientTimestamp;
  page?: number;
}
